import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import { Copy } from "lucide-react";
import LayOut from "../components/LayOut";
import "./Styles/singleblog.css";

const EducationBlogPage = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await axios.get(
          `https://portfoliomern-mxue.onrender.com/api/v1/blog/blog/${id}`
        );
        setBlog(response.data.blog);
      } catch (error) {
        console.error("Error fetching educational blog:", error);
      }
    };
    fetchBlog();
  }, [id]);

  const handleCopy = () => {
    if (blog?.code) {
      navigator.clipboard.writeText(blog.code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  // ✅ Return loading state until blog is loaded
  if (!blog) {
    return (
      <LayOut title="Education Blog">
        <div className="text-center text-light fs-4 mt-5">Loading...</div>
      </LayOut>
    );
  }

  return (
    <LayOut title={"Education Blog"}>
      <div className="container my-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="edu-blog-card shadow-lg p-4 rounded-4">
              <h1 className="text-center fw-bold edu-blog-title">
                {blog.title}
              </h1>
              <p className="text-center text-muted edu-blog-meta">
                By {blog.author || "Unknown"} |{" "}
                {new Date(blog.createdAt).toDateString()}
              </p>
              {blog.image && (
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="edu-blog-image"
                />
              )}
              <div className="mt-4 fs-5 edu-blog-content">{blog.content}</div>
              {blog.code && (
                <div className="code-section mt-4 position-relative">
                  <button className="copy-btn" onClick={handleCopy}>
                    {copied ? "Copied!" : <Copy size={18} />}
                  </button>
                  <SyntaxHighlighter
                    language="javascript"
                    style={oneDark}
                    customStyle={{ borderRadius: "8px", padding: "16px" }}
                  >
                    {blog.code}
                  </SyntaxHighlighter>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </LayOut>
  );
};

export default EducationBlogPage;
